"use client";

import { Zap } from "lucide-react";
import { Notification } from "@/types/notification";
import NotificationItem from "@/components/tailwind/notification/notificationItem";
import { useWorkspaceContext } from "@/contexts/workspaceContext";

/** Button automation "Send notification": ⚡ {actor}'s automation sent you a message. */
export default function NotificationButton({ notification }: { notification: Notification }) {
  const { getMemberName } = useWorkspaceContext();
  const displayName =
    getMemberName(notification.createdBy?.userId) ||
    getMemberName(notification.createdBy?.userEmail) ||
    notification.createdBy?.userName ||
    "Someone";

  return (
    <NotificationItem
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full border border-gray-300 text-gray-600 dark:border-gray-600 dark:text-gray-300">
          <Zap className="h-3.5 w-3.5" />
        </div>
      }
      createdAt={notification.createdAt}
      unread={!notification.read}
      title={`${displayName}’s automation`}
      message={
        <>
          sent you a message
          {notification.message && (
            <span className="mt-1 block whitespace-pre-wrap text-gray-500 dark:text-gray-400">
              {notification.message}
            </span>
          )}
        </>
      }
    />
  );
}
